export default (width) => ({
  option: (base, state) => ({
    ...base,
    display: 'flex',
    alignItems: 'center',
    padding: '0 0 0 48px',
    margin: '0',
    height: '48px',
    color: state.isFocused ? '#ffffff': '#252628',
    fontSize: '16px',
    backgroundColor: state.isFocused ? '#e67e21': '#ffffff',
    // eslint-disable-next-line max-len
    backgroundImage: state.isSelected ? 'url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNS40IDExLjIiPjxwYXRoIGQ9Ik01LjIgOC45TDEzLjguM2MuNC0uNCAxLS40IDEuMyAwIC40LjQuNCAxIDAgMS4zbC05IDljMCAuMS0uMS4yLS4yLjMtLjQuNC0xIC40LTEuMyAwTC4zIDYuNmMtLjQtLjQtLjQtMSAwLTEuMy40LS40IDEtLjQgMS4zIDBsMy42IDMuNnoiIGZpbGw9IiNiZTViMDQiLz48L3N2Zz4=)':null,
    backgroundPosition: 'left 16px center;',
    backgroundRepeat: 'no-repeat',
    ':active': {
      backgroundColor: '#e67e21',
    },
    ':last-child': {
      borderBottom: '0',
    },
    backgroundSize: '16px 12px',
  }),
  container: (base) => ({
    ...base,
    border: 'none',
    width: `${typeof width === 'number' ? `${width}px` : width}`,
    margin: '0 16px 8px 0',
    '@media (max-width: 767px)': { width: '100%' },
  }),
  input: (base) => ({
    ...base,
    visibility: 'hidden',
  }),
  valueContainer: (base) => ({
    ...base,
    padding: 0,
  }),
  indicatorSeparator: (base) => ({
    ...base,
    display: 'none',
  }),
  control: (base) => ({
    ...base,
    display: 'flex',
    boxShadow: 'none',
    padding: '0 16px',
    border: '1px solid #dcdcdc !important',
    borderRadius: '8px',
  }),
  menu: (base) => ({
    ...base,
    color: '#ffffff',
    boxShadow: '0 10px 24px 0 rgba(134, 134, 134, 0.5)',
    borderRadius: '12px',
    padding: '0',
    margin: '8px 0 0',
  }),
  indicatorsContainer: (base) => ({
    ...base,
    marginRight: '16px',
  }),
  singleValue: (base) => ({
    ...base,
    fontSize: '16px',
    padding: '0',
  }),
  menuList: (base) => ({
    ...base,
    padding: '0',
    margin: '0',
    borderRadius: '12px',
  }),
});
